import React, {useCallback, useEffect, useRef, useState} from "react";
import {Link, useNavigate, useParams, useSearchParams} from "react-router-dom";
import CommonLayout from "../layout/CommonLayout";
import BackClick from "../components/BackClick";
import SingleCartProduct from "../components/cartelements/SingleCartProduct";
import coupon from "../assets/images/icons/applyCouponIcon.svg";
import arrow from "../assets/images/icons/checkCouponArrow.svg";
import {useDispatch, useSelector} from "react-redux";
import {getCoupon} from "../reducer/couponSlice";
import Loader from "../components/loader/Loader";
import {apiBaseUrl} from "../config";
import {getCartInfo} from "../reducer/userCartSlice";
import {BsCart3} from "react-icons/bs";
import {RiArrowDropUpLine} from "react-icons/ri";
import {RiArrowDropDownLine} from "react-icons/ri";
import {useLocation} from "react-router-dom";
import {load} from "@cashfreepayments/cashfree-js";
import randomString from "randomstring";
import axios from "axios";
import CouponModal from "../components/CouponModal/CouponModal";
import {MdAddBox} from "react-icons/md";
import InfoDialog from "../components/dialog/InfoDialog";
import {formatDateToCustom, getDomainInfo} from "../utils/utils";
import CommonButton from "../components/CommonButton";
import {getUserInfo} from "../reducer/userInfoSlice";
import TotalPayment from "./TotalPayment";
import PaymentMethods from "../components/cartelements/PaymentMethods";
import AddressComponent from "../components/cartelements/AddressComponent";
import CouponComponent from "../components/cartelements/CouponComponent";
import { useUser } from "../context/userContext";
import { toast } from "react-toastify";


function Cart() {
    const location = useLocation()
    const [isCartLoginRequired, setCartLoginRequired] = useState(false);
    const [isOtpVerificationRequired, setOtpVerificationRequired] = useState(false);
    const [searchParams] = useSearchParams();
    const source = searchParams?.get("source");
    const navigate = useNavigate();
    const [cartItems, setCartitems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [shippingfee, setShippingfee] = useState([]);
    const [pgfee, setPgfee] = useState([]);
    const [pgfeelivestatus, setpgfeelivestatus] = useState(0);
    const [shippingfeelivestatus, setshippingfeelivestatus] = useState(0);
    const [shippingfeestatus, setshippingfeestatus] = useState([]);
    ;
    const [pgfeestatus, setpgfeestatus] = useState([]);
    ;
    const currentCoupon = useSelector((state) => state.couponControl?.coupon);
    const dispatch = useDispatch();
            const [loadingO, setLoadingO] = useState(false);

    const storedCartItems =
        useSelector((state) => state.fetchCart?.cartInfo?.cartItem) || [];
    const token = localStorage.getItem("token");
    const cartContext = localStorage.getItem("cartContext");

    const customerId = localStorage.getItem("customerId");

    const [message, setMessage] = useState(""); // State to store the incoming message
    const [isConnected, setIsConnected] = useState(false);
    const [socket, setSocket] = useState(null);

    const discountprice = localStorage.getItem("discountamt");
    const [addresses, setAddresses] = useState([]);
    const [defaultAddress, setDefaultAddress] = useState({});
    const [selected, setSelected] = useState(null);
    const addressList = useSelector((state) => state.address?.addressList);
    const orderDateTime =formatDateToCustom( new Date())
    const [refreshAddresses, setRefreshAddresses] = useState(false);
    const userAvaterImg = useSelector((state) => state.fetchUser?.user?.profileImg);
    const storeusername = useSelector((state) => state.fetchUser?.user?.username);
    const usermobile = localStorage.getItem("usermob");
    const storephone = useSelector((state) => state.fetchUser?.user?.phone);
    const storeemail = useSelector((state) => state.fetchUser?.user?.email);
    const SelectedEmail = localStorage.getItem("selected-email");
    const Selectedaddress = JSON.parse(localStorage.getItem("selected-address"));
    const selectedName = localStorage.getItem("selected-name");
    const storeid = localStorage.getItem("storeid");
    const [marchentId, setmarchentId] = useState();
    const [isCartItemUpdated, setIsCartItemUpdated] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [infoMessage, setInfoMessage] = useState("");
    const [mobileNumber, setMobileNumber] = useState('');
    const [error, setError] = useState('');
    const cashfreeRef = useRef(null);

    const { userId } = useParams();
    const { uid,isPredefinedDomain } = getDomainInfo(userId);
    const { userData, fetchUserData } = useUser();
    const userid = useSelector((state) => state.fetchUser?.user?.id);


      useEffect(() => {
        if (uid) {
         fetchUserData(uid);
        } else {
          console.error("UID is undefined, skipping fetchUserData.");
        }
      }, [uid]);


    useEffect(() => {
        const isOrderSuccessPage = location.pathname.includes("order-successful");

        if (isOrderSuccessPage) return; // Don't validate on order success page

        if (source) {
            if ((source === "whatsapp" || source === "gmail") && token) {
            setCartLoginRequired(false);
            if (cartItems.length > 0 && userData?.id) {
                validateCart();
            }
            } else if (source === "whatsapp" || source === "gmail") {
            setCartLoginRequired(true);
            }
        } else {
            // handelprocesstobuy();
            if (cartItems.length > 0 && userData?.id) {
            validateCart();
            }
        }
    }, [source, token, cartItems, userData?.id, location.pathname]);


    const validateCart = async () => {
        if (!cartItems || cartItems.length === 0||!userData?.id||!token) {
            return;
        }

        const apiUrl = `${apiBaseUrl}customer/validate-cart`;
        try {
            const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: token,
            },
            body: JSON.stringify({ sellerId: userData?.id }),
            });

            if (response.ok) {
            const result = await response.json();
            if (!result.isValid && result.message && !result.message.includes("cart not found")) {
                setInfoMessage(result.message);
                setIsCartItemUpdated(true);
                setShowModal(true);
            }
            } else {
            console.error("validate-cart failed with status:", response.status);
            }
        } catch (error) {
            console.error("Error validating cart:", error);
        }
    };

    const cartItemsHtml = cartItems
        ?.map(
            (item) => `
   <tr >
     <td style="width:100px;"><img src="${
                item.image
            }" style="width:100px; height:100px;border:1px solid #ddd"></td>
     <td style="font-weight:500;display:flex">
       <ul style=" padding: 0; list-style: none;margin:0;display: block;">
         <li style="width:100%; text-align: left; font-weight:600;">${
                item?.title
            }</li>
         ${
                item?.variant?.secondVariant?.title?.value?.length > 0
                    ? `<li style="width:100%; text-align: left; font-weight:600;">${item.variant.secondVariant.title.value.split("||")[0]}</li>`
                    : ""
            }
         ${
                item?.variant?.firstVariant?.title?.value?.length > 0
                    ? `<li style="width:100%; text-align: left; font-weight:600;">${item.variant.firstVariant.title.value.split("||")[0]}</li>`
                    : ""
            }
         <li style="width:100%; text-align: left; font-weight:600;">Quantity: ${
                item?.quantity
            }</li>
         <li style="width:100%; text-align: left; font-weight:600;">Amount: ₹${
                (item?.price * item?.quantity)?.toLocaleString("en-IN")
            }</li>
       </ul>
     </td>
  </tr>
  `
        )
        .join("");


    // Initialize Cashfree SDK only once
    useEffect(() => {
        const initializeCashfree = async () => {
            if (!cashfreeRef.current) {
                try {
                    cashfreeRef.current = await load({
                        mode: process.env.REACT_APP_CASHFREE_MODE,
                    });
                } catch (error) {
                    console.error("Error initializing Cashfree:", error);
                }
            }
        };
        initializeCashfree();
    }, []);


    /**
     * This method is used to get payload for the order  ceations
     * @param orderId
     * @param amount
     * @returns {{amount, totalAmt: *, sellerId: string, merchantId, products: {quantity: number|number|*, productId: *, variantId: ({variantID: *}|{variantID: *})[]|*[], variantName: string}[], addressId: unknown}}
     */
    const getPayloadForCreateOrder = (orderId, amount) => {
        return {
            addressId: selected,
            amount: amount,
            totalAmt: amount,
            merchantId: orderId,
            sellerId:  userData?.id,
        };
    };

    /**
     * This method is used to do the error handling when payment is failed
     * @param orderNumber
     * @param orderOriginalId
     */
    const handlePaymentError = async (
        orderId,
        originalOrderId,
        errorMessage,
        amount
    ) => {
        const apiUrl = `${apiBaseUrl}customer/updatePaymentFailure`;
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                token: token,
            },
            body: JSON.stringify({
                originalOrderId: originalOrderId,
                errorMessage: errorMessage,
                orderId: orderId,
            }),
        });

        if (response.ok) {

            setLoadingO(false)
            navigate(isPredefinedDomain ? `/${uid}/payment-failed` : "/payment-failed");

            // sendOrderFailureMailToBuyer(orderId, amount);
            // sendOrderFailureMailToSeller(orderId, amount);
        }
        
    };

    /**
     * This method is used to send failue mail to buyer
     * @param NeworderId
     */
    // const sendOrderFailureMailToBuyer = (NeworderId, totalAmount) => {
    //     fetch(`${apiBaseUrl}mail/sendMail/`, {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //             to: SelectedEmail,
    //             subject: `Order Failed with ${storeusername} Order Number: ${NeworderId}`,
    //             html: `<!DOCTYPE html>
    // <html>
    // <head>
    // 	<meta charset="utf-8">
    // 	<meta name="viewport" content="width=device-width, initial-scale=1">
    // 	<title>Order Failure</title>
    // </head>
    // <body style="font-family: poppins;">
    // 	<style type="text/css">
    // 		@media(max-width:768px){
    // 			.order {
    // 			    margin: 0 10px!important;
    // 			    padding: 0 10px !important;
    // 			}
    // 		.order table tr th,.order table tr td{
    // 			font-size: 13px;
    // 			        padding: 0.25rem !important;
    // 		   }
    // 		  .order  h6 {
    // 		      font-size: 15px !important;
    // 		       margin: 10px 0 5px !important;

    // 			}
    // 			.order h2 {
    // 			    margin: 5px 0;
    // 			    font-size: 16px;
    // 			}
    // 			.order h2 {
    // 			    margin: 5px 0;
    // 			    font-size: 16px;
    // 			}
    // 			.order p {
    // 			    font-size: 12px;
    // 			   margin: 5px 0!important;
    // 			}	
    // 			.order img{
    // 				width: 90px!important;
    // 			}
    // 			.order h4 {
    // 			    font-size: 15px;
    // 			    padding: 5px 0!important;
    // 			    margin: 5px 0;
    // 			}
    // 			.order ul li {
    // 			    font-size: 11px !important;
    // 			}
    // 	      .sm{
    // 	      	font-size: 10px!important;
    // 	      }
    // 	      .order div {
    // 			    padding: 5px 0 !important;
    // 		  }
    // 		.order  h5 {
    // 		    font-size: 16px !important;
    // 		}
    // 		.product-table tr{
    //           display: flex;
    //         -webkit-box-orient: vertical;
    //         -webkit-box-direction: normal;
    // 		}
    // 		   .product-table tr ul li {
    // 		        width: 100% !important;
    // 		        text-align: left !important;
    // 		    }
    // 	}
    // 	</style>
    //     <section className="order" style="margin: 0 20px;padding: 20px;border: 1px solid #dddd;">
    //     	<div className="logo" style="text-align:center; " >
    // 		    	 <img src=${userAvaterImg} style="width:100px;height:133.4px;object-position: top;;object-fit: cover; padding-top: 20px;">
    // 		    	 <h2 style="margin:0px">${storeusername}</h2>
    //         </div>
    //          <table style="">
    // 			  <tr style="">
    // 			    <th style=" margin-bottom: 10px; padding: 0px;">Order Number:</th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${NeworderId}</td>
    // 			  </tr>
    // 			  <tr style="">
    // 			    <th style="text-align: left; margin-bottom: 10px; padding: 0px;">Order Date: </th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${orderDateTime}</td>
    // 			  </tr>
    // 		</table>
    // 		<h6 style="text-align:left; font-size:20px; margin: 20px 0 10px;">Dear ${selectedName},</h6>
    // 		<p style="text-align:left;">Oops, your order failed. You can try to place the order again or contact <b>${storeusername}</b> at ${storephone} or email at ${storeemail}</p>
    // 			<h4 style="border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;">Order Details</h4>
    // 			<div >
    // 				<table style="width:100%;" className="product-table">
    // 					 ${cartItemsHtml}
    // 				</table>
    // 			</div>
    // 			<div style="display:flex; border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;" >
    // 				 <div style="width:100%;">
    // 				 	 <h4 style="">Order Details</h4>
    // 				 	 <ul style="padding:0; margin:0; list-style: none;">
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Order Type: </b>${selectedPayment}</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Payment Made:  </b>${(
    //                 totalAmount - discountprice)?.toLocaleString("en-IN")
    //             }</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Balance Payment </b>0</li>
    // 				 	 </ul>
    //            	<ul style="padding:0; margin:0; list-style: none; margin-top: 0px;">
    // 				 	 	<li style="margin-bottom:10px; font-size: 15px;"><b>Sub Total: </b><span ">${totalqtyprice.toLocaleString("en-IN")}</span></li>
    // 				 	 	<li style="margin-bottom:10px; font-size: 15px;"><b>Additional Discount:</b> <span>${discountprice.toLocaleString("en-IN")}</span></li>
    // 				 	 	<li style="margin-bottom:	10px; font-size: 15px;"><b>Sum Total: </b><span >${
    //                 totalAmount - discountprice
    //             }</span></li>
    // 				 	 </ul>
    // 				 	 <p style="font-size:12px;" className="sm">(All Payments are inclusive of GST)</p>
    // 				 </div>
    // 			</div>
    // 			<div style=" padding:20px 0;">
    // 				 	 <h4 style="">Shipping Details:</h4>
    // 				 	 <ul style="padding:0; margin:0; list-style: none;">
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${selectedName}</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${
    //                 Selectedaddress?.address
    //             }, ${Selectedaddress?.district}, ${Selectedaddress?.state}, ${
    //                 Selectedaddress?.zip
    //             }</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${usermobile}</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${SelectedEmail}</li>
    // 				 	 </ul>
    // 				 	 		   <p>For any clarification, concern or query, please call <b>${storeusername}</b> at  <a href="">${storephone}</a> or email at <a href="">${storeemail}</a></p>
    // 		   </div>
    // 		    <div style="text-align:center;">
    // 		    	<h5 style="font-size:20px; margin:10px 0;">Powered by <a href="">HelloStore™</a> </h5>
    // 		   		<p style="font-size:12px;" className="sm">Disclaimer: The items have been brought by you directly from the seller: ${storeusername} The Seller is responsible for quality, delivery and servicing of the order. HelloStore is a technology provider and has no role to play in order servicing or fulfilment. For any order or servicing related issue, please contact the seller directly.</p>
    // 		    </div>

    //     </section>
    // </body>
    // </html>`,
    //         }),
    //     })
    //         .then((response) => response.json())
    //         .then((data) => {
    //             console.log("Buyer Email failed  successfully", data);
    //         })
    //         .catch((error) => {
    //             console.error("Error sending email:", error);
    //         });
    // };

    /**
     * This method is used to send order failure mail to seller
     * @param NeworderId
     */
    // const sendOrderFailureMailToSeller = (NeworderId, totalAmount) => {
    //     fetch(`${apiBaseUrl}mail/sendMail/`, {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //             to: storeemail,
    //             // to: "mr.sudarshandebnath@gmail.com",
    //             subject: `New order attempt failed: Order Number: ${NeworderId}`,
    //             html: `
    //             <!DOCTYPE html>
    // <html>
    // <head>
    // <meta charset="utf-8">
    // <meta name="viewport" content="width=device-width, initial-scale=1">
    // </head>
    // <body style="font-family: poppins;">
    // <style type="text/css">
    // @media(max-width:768px){
    //   .order {
    //       margin: 0 10px!important;
    //       padding: 0 10px !important;
    //   }
    // .order table tr th,.order table tr td{
    //   font-size: 13px;
    //           padding: 0.25rem !important;
    //    }
    // .order   h6 {
    //       font-size: 15px !important;
    //        margin: 10px 0 5px !important;

    //   }
    // .order	h2 {
    //       margin: 5px 0;
    //       font-size: 16px;
    //   }
    // .order	h2 {
    //       margin: 5px 0;
    //       font-size: 16px;
    //   }
    // .order	p {
    //       font-size: 12px;
    //      margin: 5px 0!important;
    //   }	
    // .order	img{
    //     width: 90px!important;
    //   }
    // .order	h4 {
    //       font-size: 15px;
    //       padding: 5px 0!important;
    //       margin: 5px 0;
    //   }
    // .order	ul li {
    //       font-size: 11px !important;
    //   }
    //     .sm{
    //       font-size: 10px!important;
    //     }
    //   .order  div {
    //       padding: 5px 0 !important;
    //   }
    // .order  h5 {
    //     font-size: 16px !important;
    // }
    // .product-table tr{
    //       display: flex;
    //     -webkit-box-orient: vertical;
    //     -webkit-box-direction: normal;
    // }
    //    .product-table tr ul li {
    //         width: 100% !important;
    //         text-align: left !important;
    //     }
    // }
    // </style>
    // <section className="order" style="margin: 0 20px;padding: 20px;border: 1px solid #dddd;">
    //   <div className="logo" style="text-align:center; " >
    //        <img src="https://infyedgesolutions.com/Blue_transparent.png" alt="TaptoHello Logo" style="width: 20%; padding-top: 20px; padding-bottom: 10px;">
    //     </div>
    //      <table style="">
    //      <tr style="">
    // 			    <th style=" margin-bottom: 10px; padding: 0px;">Order Number:</th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${NeworderId}</td>
    // 			  </tr>
    // 			  <tr style="">
    // 			    <th style="text-align: left; margin-bottom: 10px; padding: 0px;">Order Date: </th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${orderDateTime}</td>
    // 			  </tr>
    // </table>
    // <p style="text-align:left;">You have received an order today. Below is the order detail:</p>
    //   <h4 style="border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;">Order Details</h4>
    //   <div >
    //     <table style="width:100%;" className="product-table">
    //        ${cartItemsHtml}
    //     </table>
    //   </div>
    //   <div style="display:flex; justify-content:space-between; border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;" >
    //      <div style="width:100%;">
    //         <h4 style="">Order Details</h4>
    //         <ul style="padding:0; margin:0; list-style: none;">
    //           <li style="margin-bottom:5px; font-size: 15px;"><b>Order Type: </b>${selectedPayment}</li>
    //           <li style="margin-bottom:5px; font-size: 15px;"><b>Payment Made:  </b>${
    //                 totalAmount - discountprice
    //             }</li>
    //           <li style="margin-bottom:5px; font-size: 15px;"><b>Balance Payment </b>0 </li>
    //         </ul>
    //           <ul style="padding:0; margin:0; list-style: none; margin-top: 0px;">
    //           <li style="margin-bottom:10px; font-size: 15px;"><b>Sub Total: </b><span >${totalqtyprice.toLocaleString("en-IN")}</span></li>
    //           <li style="margin-bottom:10px; font-size: 15px;"><b>Additional Discount:</b> <span >${discountprice.toLocaleString("en-IN")}</span></li>
    //           <li style="margin-bottom:	10px; font-size: 15px;"><b>Sum Total: </b><span >${
    //                 totalAmount - discountprice
    //             }</span></li>
    //         </ul>
    //         <p style="font-size:12px;" className="sm">(All Payments are inclusive of GST)</p>
    //      </div>

    //   </div>
    //   <div style=" padding:20px 0;">
    //         <h4 style="">Shipping Details:</h4>
    //         <ul style="padding:0; margin:0; list-style: none;">
    //           <li style="margin-bottom:5px; font-size: 15px;">${selectedName}</li>
    // 				    				 	 	<li style="margin-bottom:5px; font-size: 15px;">${
    //                 Selectedaddress?.addressLine1 + Selectedaddress?.addressLine2
    //             }, ${Selectedaddress?.district}, ${
    //                 Selectedaddress?.state
    //             }, ${Selectedaddress?.zip}</li>
    //           <li style="margin-bottom:5px; font-size: 15px;">${usermobile}</li>
    //           <li style="margin-bottom:5px; font-size: 15px;">${SelectedEmail}</li>
    //         </ul>
    //    </div>
    //     <div style="text-align:center;">
    //       <h5 style="font-size:20px; margin:10px 0;">Powered by <a href="">HelloStore™</a> </h5>
    //     </div>

    // </section>
    // </body>
    // </html>
    //             `,
    //         }),
    //     })
    //         .then((response) => response.json())
    //         .then((data) => {
    //             console.log("seller Email failed  successfully", data);
    //         })
    //         .catch((error) => {
    //             console.error("Error sending email:", error);
    //         });
    // };

    /**
     * This method is used to do the handling for payment success
     * @param orderOrginalId
     * @param orderId
     * @param amount
     * @returns {Promise<void>}
     */
    const handlePaymentSuccess = async (
        originalOrderId,
        orderId,
        amount,
        successMessage,
        paymentType
    ) => {
        // Update order number
        try {
            const response = await fetch(
                `${apiBaseUrl}customer/updatePaymentSuccess`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        token,
                    },
                    body: JSON.stringify({
                        originalOrderId: originalOrderId,
                        orderNumber: orderId,
                        successMessage: successMessage,
                    }),
                }
            );
            if (response.ok) {
                const responseData = await response.json();
                const skuIds = responseData?.data?.skuIds || [];
                setLoadingO(false)
                dispatch(getCartInfo({ cartItem: [] }));
                setCartitems([]);
                localStorage.removeItem("cartContext");
                navigate(
                    isPredefinedDomain
                        ? `/${uid}/order-successful`
                        : "/order-successful",
                    {
                        state: {
                            neworderId: orderId,
                            paymentType: paymentType,
                            orderDateTime,
                            orderAmount: amount,
                            skuIds: skuIds,
                        },
                    }
                );
                // sendOrderSuccessMailToSeller(orderId, amount);
                // sendOrderSuccessMailToBuyer(orderId, amount);
            }
            else {
                const errorData = await response.json();
                const errorMessage = errorData?.error || "Something went wrong";
                toast.error(errorMessage);
            }
        } catch (error) {
            setLoadingO(false)

            console.error("Error updating order number:", error);
        }
    };

    /**
     * This method is used to send order success mail to seller
     * @param NeworderId
     */
    // const sendOrderSuccessMailToSeller = (NeworderId, totalAmount) => {
    //     fetch(`${apiBaseUrl}mail/sendMail/`, {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //             to: storeemail,
    //             // to: "mr.sudarshandebnath@gmail.com",
    //             subject: `New order received - Order Number:  ${NeworderId}`,
    //             html: `
    //                 <!DOCTYPE html>
    // <html>
    // <head>
    // 	<meta charset="utf-8">
    // 	<meta name="viewport" content="width=device-width, initial-scale=1">
    // </head>
    // <body style="font-family: poppins;">
    // 	<style type="text/css">
    // 		@media(max-width:768px){
    // 			.order {
    // 			    margin: 0 10px!important;
    // 			    padding: 0 10px !important;
    // 			}
    // 		.order table tr th,.order table tr td{
    // 			font-size: 13px;
    // 			        padding: 0.25rem !important;
    // 		   }
    // 		.order   h6 {
    // 		      font-size: 15px !important;
    // 		       margin: 10px 0 5px !important;

    // 			}
    // 		.order	h2 {
    // 			    margin: 5px 0;
    // 			    font-size: 16px;
    // 			}
    // 		.order	h2 {
    // 			    margin: 5px 0;
    // 			    font-size: 16px;
    // 			}
    // 		.order	p {
    // 			    font-size: 12px;
    // 			   margin: 5px 0!important;
    // 			}	
    // 		.order	img{
    // 				width: 90px!important;
    // 			}
    // 		.order	h4 {
    // 			    font-size: 15px;
    // 			    padding: 5px 0!important;
    // 			    margin: 5px 0;
    // 			}
    // 		.order	ul li {
    // 			    font-size: 11px !important;
    // 			}
    // 	      .sm{
    // 	      	font-size: 10px!important;
    // 	      }
    // 	    .order  div {
    // 			    padding: 5px 0 !important;
    // 		  }
    // 		.order  h5 {
    // 		    font-size: 16px !important;
    // 		}
    // 		.product-table tr{
    //           display: flex;
    //         -webkit-box-orient: vertical;
    //         -webkit-box-direction: normal;
    // 		}
    // 		   .product-table tr ul li {
    // 		        width: 100% !important;
    // 		        text-align: left !important;
    // 		    }
    // 	}
    // 	</style>
    //     <section className="order" style="margin: 0 20px;padding: 20px;border: 1px solid #dddd;">
    //     	<div className="logo" style="text-align:center; " >
    // 		    	 <img src="https://infyedgesolutions.com/Blue_transparent.png" alt="TaptoHello Logo" style="width: 20%; padding-top: 20px; padding-bottom: 10px;">
    //         </div>
    //          <table style="">
    // 			   <tr style="">
    // 			    <th style=" margin-bottom: 10px; padding: 0px;">Order Number:</th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${NeworderId}</td>
    // 			  </tr>
    // 			  <tr style="">
    // 			    <th style="text-align: left; margin-bottom: 10px; padding: 0px;">Order Date: </th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${orderDateTime}</td>
    // 			  </tr>
    // 		</table>
    // 		<p style="text-align:left;">You have received an order today. Below is the order detail:</p>
    // 			<h4 style="border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;">Order Details</h4>
    // 			<div >
    // 				<table style="width:100%;" className="product-table">
    // 					 ${cartItemsHtml}
    // 				</table>
    // 			</div>
    // 			<div style="display:flex;justify-content:space-between; border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;" >
    // 				 <div style="width:100%;">
    // 				 	 <h4 style="">Order Details</h4>
    // 				 	 <ul style="padding:0; margin:0; list-style: none;">
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Order Type: </b><span style="padding-left:10px;">${selectedPayment}</span></li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Payment Made:  </b><span style="padding-left:10px;">${
    //                 totalAmount - discountprice
    //             }</span></li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Balance Payment </b><span style="padding-left:10px;">0</span></li>
    // 				 	 </ul>
    //            	<ul style="padding:0; margin:0; list-style: none; margin-top: 0px;">
    // 				 	 	<li style="margin-bottom:10px; font-size: 15px;"><b>Sub Total: </b><span style="padding-left:10px;">${totalqtyprice.toLocaleString("en-IN")}</span></li>
    // 				 	 	<li style="margin-bottom:10px; font-size: 15px;"><b>Additional Discount:</b> <span style="padding-left:10px;">${discountprice.toLocaleString("en-IN")}</span></li>
    // 				 	 	<li style="margin-bottom:	10px; font-size: 15px;"><b>Sum Total: </b><span style="padding-left:10px;">${
    //                 totalAmount - discountprice
    //             }</span></li>
    // 				 	 </ul>
    // 				 	 <p style="font-size:12px;" className="sm">(All Payments are inclusive of GST)</p>
    // 				 </div>

    // 			</div>
    // 			<div style=" padding:20px 0;">
    // 				 	 <h4 style="">Shipping Details:</h4>
    // 				 	 <ul style="padding:0; margin:0; list-style: none;">
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${selectedName}</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${
    //                             Selectedaddress?.addressLine1 + Selectedaddress?.addressLine2
    //             }, ${Selectedaddress?.district}, ${Selectedaddress?.state}, ${
    //                 Selectedaddress?.zip
    //             }</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${usermobile}</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${SelectedEmail}</li>
    // 				 	 </ul>
    // 				 	<p>Please pack the order and ship it to the consignee. Please share the tracking details with the buyer as soon as the order is shipped.</p>
    // 		   </div>
    // 		    <div style="text-align:center;">
    // 		    	<h5 style="font-size:20px; margin:10px 0;">Powered by <a href="">HelloStore™</a> </h5>
    // 		    </div>

    //     </section>
    // </body>
    // </html>
    //                 `,
    //         }),
    //     })
    //         .then((response) => response.json())
    //         .then((data) => {
    //             console.log("seller Email sent  successfully", data);
    //         })
    //         .catch((error) => {
    //             console.error("Error sending email:", error);
    //         });
    // };

    /**
     * This method is used to send order success mail to buyer
     * @param NeworderId
     */
    // const sendOrderSuccessMailToBuyer = (NeworderId, totalAmount) => {
    //     fetch(`${apiBaseUrl}mail/sendMail/`, {
    //         method: "POST",
    //         headers: {
    //             "Content-Type": "application/json",
    //         },
    //         body: JSON.stringify({
    //             to: SelectedEmail,
    //             subject: `Order successfully placed with ${storeusername} Order Number: ${NeworderId}`,
    //             html: `
    //       <!DOCTYPE html>
    // <html>
    // <head>
    // 	<meta charset="utf-8">
    // 	<meta name="viewport" content="width=device-width, initial-scale=1">
    // 	<title>Order Sucess Buyer</title>
    // </head>
    // <body style="font-family: poppins;">
    // 	<style type="text/css">
    //   .im{
    //   width:60%;
    //   }
    // 		@media(max-width:768px){
    // 		.order	section {
    // 			    margin: 0 10px!important;
    // 			    padding: 0 10px !important;
    // 			}
    // 		.order table tr th,.order table tr td{
    // 			font-size: 13px;
    // 			        padding: 0.25rem !important;
    // 		   }
    // 		   .order h6 {
    // 		      font-size: 15px !important;
    // 		       margin: 10px 0 5px !important;

    // 			}
    // 		.order	h2 {
    // 			    margin: 5px 0;
    // 			    font-size: 16px;
    // 			}
    // 			.order h2 {
    // 			    margin: 5px 0;
    // 			    font-size: 16px;
    // 			}
    // 		.order	p {
    // 			    font-size: 12px;
    // 			   margin: 5px 0!important;
    // 			}	

    // 		.order	img{
    // 				width: 90px!important;
    // 			}
    // 		.order	h4 {
    // 			    font-size: 15px;
    // 			    padding: 5px 0!important;
    // 			    margin: 5px 0;
    // 			}
    // 		.order	ul li {
    // 			    font-size: 11px !important;
    // 			}
    // 	      .sm{
    // 	      	font-size: 10px!important;
    // 	      }
    // 	    .order  div {
    // 			    padding: 5px 0 !important;
    // 		  }
    // 		.order  h5 {
    // 		    font-size: 16px !important;
    // 		}
    // 		.product-table tr{
    //           display: flex;
    //         -webkit-box-orient: vertical;
    //         -webkit-box-direction: normal;
    // 		}
    // 		   .product-table tr ul li {
    // 		        width: 100% !important;
    // 		        text-align: left !important;
    // 		    }
    // 	}
    // 	</style>
    //     <section className="order" style="margin: 0 20px;padding: 20px;border: 1px solid #dddd;">
    //     	<div className="logo" style="text-align:center; " >
    // 		    	 <img src=${userAvaterImg} style="width: 100px;height:133.4px;object-position: top;;object-fit: cover; padding-top: 20px; padding-bottom: 0px;">
    // 		    	 <h2 style=" margin: 0;">${storeusername}</h2>
    //         </div>
    //          <table style="">
    // 			  <tr style="">
    // 			    <th style=" margin-bottom: 10px; padding: 0px;">Order Number:</th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${NeworderId}</td>
    // 			  </tr>
    // 			  <tr style="">
    // 			    <th style="text-align: left; margin-bottom: 10px; padding: 0px;">Order Date: </th>
    // 			    <td style="margin-bottom: 10px; padding: 0px;">${orderDateTime}</td>
    // 			  </tr>
    // 		</table>
    // 		<h6 style="text-align:left; font-size:20px; margin: 20px 0 10px;">Dear ${selectedName},</h6>
    // 		<p style="text-align:left;">Thank you for shopping with <b>${storeusername}</b>. We wish to confirm that we have received your order.</p>
    // 			<h4 style="border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;">Order Details</h4>
    // 			<div >
    // 				<table style="width:100%;" className="product-table">
    //         ${cartItemsHtml}
    // 				</table>
    // 			</div>
    // 			<div style="display:flex;justify-content:space-between; border-top:1px solid #ddd; border-bottom: 1px solid #ddd; padding:20px 0;" >
    // 				 <div style="width:100%;">
    // 				 	 <h4 style="">Order Details</h4>
    // 				 	 <ul style="padding:0; margin:0; list-style: none;">
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Order Type: </b><span style="padding-left:10px;">${selectedPayment}</span></li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Payment Made:  </b><span style="padding-left:10px;">${
    //                 totalAmount - discountprice
    //             }</span></li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;"><b>Balance Payment </b><span style="padding-left:10px;">0</span></li>
    // 				 	 </ul>
    //            	<ul style="padding:0; margin:0; list-style: none; margin-top: 0px;">
    // 				 	 	<li style="margin-bottom:10px; font-size: 15px;"><b>Sub Total: </b><span style="padding-left:10px;">${totalqtyprice.toLocaleString("en-IN")}</span></li>
    // 				 	 	<li style="margin-bottom:10px; font-size: 15px;"><b>Additional Discount:</b> <span style="padding-left:10px;">${discountprice.toLocaleString("en-IN")}</span></li>
    // 				 	 	<li style="margin-bottom:	10px; font-size: 15px;"><b>Sum Total: </b><span style="padding-left:10px;">${
    //                 totalAmount - discountprice
    //             }</span></li>
    // 				 	 </ul>
    // 				 	 <p style="font-size:12px;" className="sm">(All Payments are inclusive of GST)</p>
    // 				 </div>

    // 			</div>
    // 			<div style=" padding:20px 0;">
    // 				 	 <h4 style="">Shipping Details:</h4>
    // 				 	 <ul style="padding:0; margin:0; list-style: none;">
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${selectedName}</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${
    //                             Selectedaddress?.addressLine1 + Selectedaddress?.addressLine2
    //             }, ${Selectedaddress?.district}, ${Selectedaddress?.state}, ${
    //                 Selectedaddress?.zip
    //             }</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${usermobile}</li>
    // 				 	 	<li style="margin-bottom:5px; font-size: 15px;">${SelectedEmail}</li>
    // 				 	 </ul>
    // 				 	 		   <p>We will pack the order and ship it to you. We will share the tracking details as soon as the order is shipped.</p>
    // 				 	 		   <p>For any clarification, concern or query, please call <b>${storeusername}</b> at  <a href="">${storephone}</a> or email at <a href="">${storeemail}</a></p>
    // 		   </div>
    // 		    <div style="text-align:center;">
    // 		    	<h5 style="font-size:20px; margin:10px 0;">Powered by <a href="">HelloStore™</a> </h5>
    // 		   		<p style="font-size:12px;" className="sm">Disclaimer: The items have been brought by you directly from the seller: ${storeusername} The Seller is responsible for quality, delivery and servicing of the order. HelloStore is a technology provider and has no role to play in order servicing or fulfilment. For any order or servicing related issue, please contact the seller directly.</p>
    // 		   		<img src="https://infyedgesolutions.com/Blue_transparent.png" style="width: 25%; padding-top: 10px; padding-bottom: 10px;">

    // 		    </div>

    //     </section>
    // </body>
    // </html>
    //       `,
    //         }),
    //     })
    //         .then((response) => response.json())
    //         .then((data) => {
    //             console.log("Buyer Email sent  successfully", data);
    //         })
    //         .catch((error) => {
    //             console.error("Error sending email:", error);
    //         });
    // };

    const placeOrder = async (
    
        amount = totalAmountOfProduct,
        orderId = randomString.generate(10),
        customerId = usermobile,
        customerContactNumber = usermobile
    ) => {



        if (!isCartItemUpdated) {
                setLoadingO(true)

            const apiUrl = `${apiBaseUrl}customer/create-order`;
            const payload = getPayloadForCreateOrder(orderId, amount);
            const fieldsToExclude = ["id", "userid"];

            const updatedCart = cartItems.map((obj) => {
                const newObj = {...obj};
                fieldsToExclude.forEach((field) => delete newObj[field]);
                return newObj;
            });

            try {
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        token: token,
                    },
                    body: JSON.stringify({
                        ...payload,
                        payment_type: selectedPayment
                    }),
                });

                if (response.ok) {
                    const result = await response.json();
                    // console.log("Backend response:", result);

                    const orderOrginalId = result.order.id;
                    const newOrderId = result.order.orderId;
                    const orderSplits = result.order.order_splits;
                    // console.log("Order Splits:", orderSplits);

                    // Set up common order data structure for both payment methods
                    const orderData = {
                        order_amount: amount,
                        order_currency: "INR",
                        order_id: orderId,
                        seller_Id:  userData?.id,

                        customer_details: {
                            customer_id: customerId,
                            customer_name: selectedName,
                            customer_email: SelectedEmail,
                            customer_phone: customerContactNumber,
                            product_info: updatedCart,
                        },
                        ...(orderSplits && {order_splits: orderSplits})
                    };

                    // For COD orders, bypass payment gateway and place order directly
                    if (selectedPayment === 'COD') {
                        // Handle COD order directly
                        await handlePaymentSuccess(
                            orderOrginalId,
                            newOrderId,
                            amount,
                            "COD order placed successfully",
                            selectedPayment
                        );
                        return;
                    }

                    // For online payment, add order_meta and proceed with Cashfree
                    const onlineOrderData = {
                        ...orderData,
                        order_meta: {
                            return_url:
                                "https://www.cashfree.com/devstudio/preview/pg/web/popupCheckout?order_id=" +
                                orderId,
                        },
                    };
                    
                    axios
                        .post(apiBaseUrl + "pay", onlineOrderData)
                        .then(async (response) => {
                            if (!cashfreeRef.current) {
                                console.error("Cashfree SDK not initialized");
                                return;
                            }

                            let checkoutOptions = {
                                paymentSessionId: response.data.payment_session_id,
                                redirectTarget: "_modal",
                            };
                            
                            cashfreeRef.current.checkout(checkoutOptions).then(async (result) => {
                                if (result.error) {
                                    console.error("error while doing payment");
                                    if (result.error.code !== "payment_aborted") {
                                        await handlePaymentError(
                                            newOrderId,
                                            orderOrginalId,
                                            result.error.message,
                                            selectedPayment
                                        );
                                    }
                                } else if (result.paymentDetails) {
                                    // console.log("payment successful");
                                    await handlePaymentSuccess(
                                        orderOrginalId,
                                        newOrderId,
                                        amount,
                                        result.paymentDetails.paymentMessage,
                                        selectedPayment
                                    );
                                }
                                setLoadingO(false)
                            });
                            localStorage.setItem("OrginalOrderId",newOrderId);
                        })


                        .catch((error) => {console.log(error)
                            setLoadingO(false)
                        });
                }
                 else {
                const errorData = await response.json();
                const errorMessage = errorData?.error || "Something went wrong";
                toast.error(errorMessage);
            }


                
                                            setLoadingO(false)

            } catch (error) {

                            setLoadingO(false)

                console.error("Error while creating order");
                console.error(error.message);
            }
        } else {
            setShowModal(true);
        }
    };
    useEffect(() => {
        const fetchAddresses = async () => {
            const token = localStorage.getItem("token");
           if(token){ try {
                const response = await fetch(
                    `${apiBaseUrl}customer/get-all-addresses`,
                    {
                        method: "GET",
                        headers: {
                            token: token,
                        },
                    }
                );
                const data = await response.json();
                // to select the default address to show on the cart screen
                if(data?.defaultAddress) {
                    setDefaultAddress(data?.defaultAddress);
                    setSelected(data?.defaultAddress?._id)
                    localStorage.setItem("selected-address", JSON.stringify(data?.defaultAddress));
                    localStorage.setItem("selected-email", data?.defaultAddress?.email);
                    localStorage.setItem("selected-name", data?.defaultAddress?.name);
                }else if(data?.addresses?.length > 0){
                    setDefaultAddress(data?.addresses[0]);
                    setSelected(data?.addresses[0]?._id);
                    localStorage.setItem("selected-address", JSON.stringify(data?.addresses[0]));
                    localStorage.setItem("selected-email",data?.addresses[0]?.email);
                    localStorage.setItem("selected-name", data?.addresses[0]?.name);
                }
                setAddresses(data.addresses || []);
            } catch (error) {
                console.error("Error fetching addresses:", error);
            }}
        };

        fetchAddresses();
    }, [token, refreshAddresses]);

    /*useEffect(() => {
        console.log("going to open to open the connection");
        // Create a WebSocket connection when the component mounts
        const ws = new WebSocket("ws://localhost:8080/"); // Connect to your WebSocket server
        setSocket(ws);

        // Listen for messages from the WebSocket server
        ws.onmessage = (event) => {
            console.log("Message received from server:", event.data);
            setMessage(event.data); // Update the state with the incoming message
        };

        // Connection open handler
        ws.onopen = () => {
            setIsConnected(true);
        };

        // Connection close handler
        ws.onclose = () => {
            setIsConnected(false);
        };

        // Cleanup on component unmount
        return () => {
            if (ws) {
                ws.close(); // Close the WebSocket connection when the component unmounts
            }
        };
    }, []);*/

    const [percentagedata, setPercentagedata] = useState({
        shippingpercentage: "",
        pgfeepercentage: "",
    });
// console.log(userData?.id,'userid', token,'token', customerId,'customer', cartContext,'cartcontext', storedCartItems,'cart items')
    useEffect(() => {
        if (storedCartItems && storedCartItems.length > 0) {
            const filteredCartItems = storedCartItems.filter(
                (item) => item.storeid ===  userData?.id
            );
            setCartitems(filteredCartItems);
        }
        else{
            const loadCartItems = async () => {
                try {
                    if (!userData?.id) {
                        console.warn("userData?.id is undefined, waiting for user data...");
                        return;
                        }

        if(userData&&userData.id&&cartContext)
            {  const response = await fetch(`${apiBaseUrl}cart/fetch-user-cart`, {
            method: "POST",
            headers: {"Content-Type": "application/json",...(token && { token: token }),},
            body: JSON.stringify({
              storeid: userData?.id,
              customerId: customerId,
              cartContext: cartContext,
            }),
                    });

                    const data = await response.json();

                    if (data?.cart) {
                        if(data.cart.cartItem?.length > 0){
                            const filteredCartItems = data.cart.cartItem.filter(
                                (item) => item.storeid ===  userData?.id
                            );
                            setCartitems(filteredCartItems);
                            //dispatch(getCartInfo(data.cart));
                        }
                    }}
                } catch (error) {
                    console.error("Error fetching User Cart Information:", error);
                }
            }
            loadCartItems();
        }
    }, [userData?.id, token, customerId, cartContext,storedCartItems&&storedCartItems[0]]);
    // }, [userData?.id, token, customerId, cartContext, storedCartItems]);

    const deleteItemFromCart = (deletedCartItem) => {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await fetch(
                    `${apiBaseUrl}cart/delete-item-from-cart`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            token: token,
                        },
                        body: JSON.stringify({
                            storeid:  userData?.id,
                            id: deletedCartItem?.productId,
                            variant: deletedCartItem?.variant,
                            cartContext: cartContext,
                            customerId: customerId,
                        }),
                    }
                );
                const data = await response.json();
                dispatch(getCartInfo(data?.cart));
                if (data?.code === "CART_EMPTY") {
                    localStorage.removeItem("cartContext");
                }
                resolve(data?.cart?.cartItem);
            } catch (e) {
                console.error("error while deleting the item from cart");
                reject(e);
            }
        });
    };

    const handleQuantityChange = (index, newQuantity) => {
        const updatedCartItems = [...cartItems];
        setLoading(true);
        if (updatedCartItems) {
            const item = updatedCartItems[index];
            const productId = item?.productId;
            if (productId) {
                updateProductQuantity(newQuantity, productId, item?.variant).then(
                    (cartItem) => {
                        if (cartItem) {
                            setCartitems([...cartItem]);
                        }
                        setLoading(false);
                    },
                    (error) => {
                        setLoading(false);
                        console.error(
                            `Error occurred while updating the item quantity in cart: ${error}`
                        );
                    }
                );
            }
        }
    };

    /**
     * This method is used to update product quantity
     * @param quantity
     * @param productId
     * @param variant
     * @returns {Promise<unknown>}
     */
    const updateProductQuantity = async (quantity, productId, variant) => {
        return new Promise(async (resolve, reject) => {
            try {
                let headers = {
                    "Content-Type": "application/json",
                };
                if (token) {
                    headers["token"] = token;
                }
                const response = await fetch(
                    `${apiBaseUrl}cart/update-item-quantity-in-cart`,
                    {
                        method: "POST",
                        headers: headers,
                        body: JSON.stringify({
                            storeid:  userData?.id,
                            id: productId,
                            quantity: quantity,
                            variant: variant,
                            cartContext: cartContext,
                            customerId: customerId,
                        }),
                    }
                );
                const data = await response.json();
                dispatch(getCartInfo(data?.cart));
                resolve(data?.cart?.cartItem);
            } catch (e) {
                console.error("error while updating the quantity of product");
                reject(e);
            }
        });
    };

    const calculateTotal = () => {
        let totalCartValue = cartItems.reduce((total, item) => {
            const itemQuantity = item.quantity || 1;
            const itemTotal = (item.price===0 ? item.mrp : item.price) * itemQuantity;
            // console.log(
            //     `Item: ${item.title}, Price: ${item.price}, Quantity: ${itemQuantity}, Item Total: ${itemTotal}`
            // );
            return total + itemTotal;
        }, 0);

        // console.log(`Total Cart Value: ${totalCartValue}`);

        const shippingCharges =
            cartItems.length === 0
                ? 0
                : shippingfeestatus === 1
                ? shippingfee
                : percentagedata.shippingpercentage;
        // console.log(`Shipping Charges: ${shippingCharges}`);

        const paymentGatewayCharges =
            cartItems.length === 0
                ? 0
                : pgfeestatus === 1
                ? pgfee
                : percentagedata.pgfeepercentage;
        // console.log(`Payment Gateway Charges: ${paymentGatewayCharges}`);

        const couponDiscount = currentCoupon !== "" ? 10 : 0;
        // console.log(`Coupon Discount: ${couponDiscount}`);

        const total =
            Number(totalCartValue) +
            Number(shippingCharges) +
            Number(paymentGatewayCharges) -
            Number(couponDiscount);
        // console.log(`Total: ${total}`);

        return total;
    };


    const calculateTotalMrp = () => {
        let totalCartValue = cartItems.reduce((total, item) => {
            const itemQuantity = item.quantity || 1;
            let itemTotal = 0;
            if(item?.variant?.variant4?.title){
                itemTotal = item?.variant?.variant4?.title * itemQuantity;
                // console.log(
                //     `Item: ${item.title}, Price: ${item?.variant?.variant4?.title}, Quantity: ${itemQuantity}, Item Total: ${itemTotal}`
                // );
            }
            return total + itemTotal;
        }, 0);

        // console.log(`Total Cart Value: ${totalCartValue}`);

        const shippingCharges =
            cartItems.length === 0
                ? 0
                : shippingfeestatus === 1
                ? shippingfee
                : percentagedata.shippingpercentage;
        // console.log(`Shipping Charges: ${shippingCharges}`);

        const paymentGatewayCharges =
            cartItems.length === 0
                ? 0
                : pgfeestatus === 1
                ? pgfee
                : percentagedata.pgfeepercentage;
        // console.log(`Payment Gateway Charges: ${paymentGatewayCharges}`);

        const couponDiscount = currentCoupon !== "" ? 10 : 0;
        // console.log(`Coupon Discount: ${couponDiscount}`);

        const total =
            Number(totalCartValue) +
            Number(shippingCharges) +
            Number(paymentGatewayCharges) -
            Number(couponDiscount);
        // console.log(`Total: ${total}`);

        return total;
    };


    const totalAmountOfProduct = calculateTotal();
    const totalMrpOfProduct = calculateTotalMrp();
    const couponDiscountAmount = currentCoupon ? 10 : 0;
    const shippingCharges =
        cartItems.length === 0
            ? 0
            : shippingfeestatus === 1
            ? shippingfee
            : percentagedata.shippingpercentage;
    const paymentGatewayCharges =
        cartItems.length === 0
            ? 0
            : pgfeestatus === 1
            ? pgfee
            : percentagedata.pgfeepercentage;
    const totalShippingAndPayment =
        Number(shippingCharges) + Number(paymentGatewayCharges);
    const totalqtyprice = Number(totalAmountOfProduct) - totalShippingAndPayment;
    const totalMrpPrice = Number(totalMrpOfProduct) - totalShippingAndPayment;

    // shipping fee
    useEffect(() => {
        const fetchShippingFee = async () => {

            if(token){
            try {
                const response = await fetch(
                    `${apiBaseUrl}lFee/getLogisticsFee/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            token: token,
                        },
                        body: JSON.stringify({userId:  userData?.id}),
                    }
                );

                const data = await response.json();
                const shippingFeePercentage = Number(shippingfee) / 100;
                const totalAmountAfterShipping = Number(totalqtyprice);
                const calculatedValue =
                    shippingFeePercentage * totalAmountAfterShipping;
                const roundedValue = Math.ceil(calculatedValue);
                setshippingfeelivestatus(data?.data?.status);
                if (shippingfeelivestatus === 1) {
                    setShippingfee(data.data?.feeValue);
                } else if (shippingfeelivestatus === 0) {
                    setShippingfee(0);
                }
                setshippingfeestatus(data?.data?.type);
                setPercentagedata((prevState) => ({
                    ...prevState,
                    shippingpercentage: roundedValue,
                }));
            } catch (err) {
                console.error("Error fetching logistics fee:", err);
            }}
        };

        fetchShippingFee();
    }, [ userData?.id, token, totalqtyprice, shippingfee, shippingfeelivestatus]);

    // Pg Fee
    useEffect(() => {
        const fetchPgFee = async () => {
            try {
                const response = await fetch(
                    `${apiBaseUrl}pFee/getPgFee/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            token: token,
                        },
                        body: JSON.stringify({userId:  userData?.id}),
                    }
                );

                const data = await response.json();
                const calculatedValue = (pgfee / 100) * totalqtyprice;
                const roundedValue = Math.ceil(calculatedValue);
                setpgfeelivestatus(data.data?.status);
                if (pgfeelivestatus === 1) {
                    setPgfee(data.data?.feeValue);
                } else if (pgfeelivestatus === 0) {
                    setPgfee(0);
                }
                setpgfeestatus(data?.data?.type);
                setPercentagedata((prevState) => ({
                    ...prevState,
                    pgfeepercentage: roundedValue,
                }));
            } catch (err) {
                console.error("Error fetching logistics fee:", err);
            }
        };

        fetchPgFee();
    }, [ userData?.id, token, totalqtyprice, pgfee, pgfeelivestatus]);

    // const handelprocesstobuy = () => {
    //     if (token) {
    //         localStorage.setItem("discountamt", couponDiscountAmount);
    //     } else {
    //         navigate(isPredefinedDomain ? `/${uid}/login` : "/login", {state: {isComeFromCheckout:true}});
    //     }
    // };


    const [isExpanded, setIsExpanded] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [appliedCoupon, setAppliedCoupon] = useState(null);
    const [coupons, setCoupons] = useState([]);
    const [isAddressModalOpen, setAddressModalOpen] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState(""); 

    useEffect(() => {
        const fetchAddresses = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}customer/get-all-addresses`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "token": token,
                    },
                });
                const data = await response.json();
                // console.log("default Address 2")
                // console.log(data?.defaultAddress)
                //setDefaultAddress(data?.defaultAddress);
                setAddresses(data?.addresses);
            } catch (error) {
                console.error("Error fetching addresses:", error);
            }
        };

        fetchAddresses();
    }, [setRefreshAddresses]);

    const delcartitem = (index) => {
        const deletedCartItem = cartItems.filter((_, i) => i === index);
        if (deletedCartItem && deletedCartItem.length > 0) {
            setIsLoading(true);
            deleteItemFromCart(deletedCartItem[0]).then(
                (cartItem) => {
                    if (cartItem) {
                        setCartitems([...cartItem]);
                    }
                    window.location.reload()
                    setIsLoading(false);
                },
                (error) => {
                                        window.location.reload()

                    setIsLoading(false);
                    console.error(`error while deleting the item from cart : ${error}`);
                }
            );
        }
    };

    const [loginstatus, setLoginstatus] = useState();
    const [values, setValues] = useState(['', '', '', '']);
    const inputRefs = useRef([]);
    const [timer, setTimer] = useState(300);
    const [loading, setLoading] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const formatTimer = (time) => {
        const minutes = String(Math.floor(time / 60)).padStart(2, '0');
        const seconds = String(time % 60).padStart(2, '0');
        return `${minutes}:${seconds} Sec`;
    };

    const handleOtpInputChange = useCallback((index, e) => {
        const value = e.target.value;
        if (value.length <= 1 && /^[0-9]*$/.test(value)) {
            const newValues = [...values];
            newValues[index] = value;
            setValues(newValues);

            if (value && index < inputRefs.current.length - 1) {
                inputRefs.current[index + 1].focus();
            } else if (!value && index > 0) {
                inputRefs.current[index - 1].focus();
            }
        }
    }, [values]);

    const handleInputChange = (event) => {
        setMobileNumber(event.target.value);
        if (error) setError('');
    };

    // const handleButtonClick = async (e) => {
    //     e.preventDefault();
    //     if (mobileNumber.length !== 10 || !/^\d{10}$/.test(mobileNumber)) {
    //         setError('Please enter a valid 10-digit number');
    //         return;
    //     }

    //     const apiUrl = `${apiBaseUrl}customer/login`;
    //     const payload = {
    //         mobile: `91${mobileNumber}`
    //     };

    //     try {
    //         const response = await fetch(apiUrl, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json"
    //             },
    //             body: JSON.stringify(payload)
    //         });

    //         const result = await response.json();

    //         if (response.ok) {
    //             setCartLoginRequired(false);
    //             setOtpVerificationRequired(true)
    //         } else {
    //             console.error("Error sending OTP:", result);
    //         }
    //     } catch (error) {
    //         console.error("Error:", error);
    //     }
    // };

    useEffect(() => {
        if (mobileNumber) {
            const url = `${apiBaseUrl}customer/customer-status`;

            fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "mobile": mobileNumber
                })
            })
                .then(response => response.json())
                .then(data => {
                    setLoginstatus(data?.status);
                })
                .catch(error => {
                    console.error("Error:", error);
                });
        }
    }, [mobileNumber]);

    const handleResendClick = useCallback(() => {
        setTimer(300);
    }, []);

    const handleVerifyClick = useCallback(async (e) => {
        e.preventDefault();
        setLoading(true)
        if (loginstatus === 0 && !isCheckboxChecked) {
            setErrorMessage("Please agree to the Terms and Conditions.");
            setLoading(false);
            return;
        }

        const otp = values.join('');
        try {
            const response = await fetch(`${apiBaseUrl}customer/otp-verify`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    "user_number": mobileNumber,
                    "otp": Number(otp),
                    "cartContext": cartContext
                })
            });
            const data = await response.json();
            dispatch(getUserInfo(data?.user))
            if (response.ok) {
                localStorage.setItem('token', data?.token);
                localStorage.setItem('usermob', data?.user?.phone);
                localStorage.setItem('customerId', data?.user?._id)
                localStorage.removeItem("cartContext");
                if (data?.token) {
                    setLoading(true)
                    await fetchUserCartInfo( userData?.id, data.token, data?.user?._id)
                        .then((data) => {
                            if (data?.cart?.cartItem?.length > 0) {
                                setOtpVerificationRequired(false);
                                setRefreshAddresses(true);
                            } else {
                               navigate(isPredefinedDomain ? `/${uid}`:"/");
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.error(
                                `Error occurred while fetch the user cart ${error}`
                            );
                        });
                } else {
                    setLoading(false)
                    navigate(isPredefinedDomain ? `/${uid}`:"/");
                }
            } else {
                setErrorMessage(data.message || "Verification failed. Please try again.");
                setLoading(false)
            }
        } catch (error) {
            setErrorMessage("An error occurred. Please try again later.");
            setLoading(false)
        }
    }, [values, mobileNumber, navigate,  userData?.id, loginstatus, isCheckboxChecked]);

    /**
     * This method is sued to fetch user cart information once user is logged in
     * @param storeId
     * @param token
     * @param customerId
     * @returns {Promise<unknown>}
     */
    const fetchUserCartInfo = (storeId, token, customerId) => {
        return new Promise(async (resolve, reject) => {
            if (token) {
                try {
                    const response = await fetch(
                        `${apiBaseUrl}cart/fetch-user-cart`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "token": token
                            },
                            body: JSON.stringify({
                                "storeid": storeId,
                                "customerId": customerId
                            })
                        }
                    );
                    const data = await response.json();
                    dispatch(getCartInfo(data?.cart));
                    resolve(data);
                } catch (e) {
                    console.error("error while fetch user cart information")
                    reject(e);
                }
            }
        });
    }

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimer(prevTimer => {
                if (prevTimer <= 0) {
                    clearInterval(intervalId);
                    return 0;
                }
                return prevTimer - 1;
            });
        }, 1000);

        return () => clearInterval(intervalId);
    }, []);

    // fetch cart discounts 
    useEffect(() => {
        const fetchCartDiscounts = async () => {
            try {
                const response = await fetch(
                    `${apiBaseUrl}discount/cart-discounts`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            // token: token,
                        },
                        body: JSON.stringify({
                            storeid:  userData?.id,
                            customerId: customerId,
                            cartItems: cartItems,
                        }),
                    }
                );
                const data = await response.json();
                // console.log("🚀 ~ fetchCartDiscounts ~ data:", data)
                setCoupons(data?.data || []);
            } catch (error) {
                console.error("Error fetching coupons:", error);
            }
        };

        if(userData&&userData.id){
        fetchCartDiscounts();}
    }, [ userData?.id, customerId, cartItems]);

    return (
        <CommonLayout>
            <BackClick/>
            {loading && <Loader/>}
            <div
                style={{
                    marginTop: "5px",
                    padding: "10px",
                    minHeight: "92vh",
                    height: "fit-content",
                    paddingBottom: "20px", 
                }}
            >
                {/* ORDER SUMMARAY */}

                <div className="product-container">
                    {/* Toggle Header */}
                    <div className="order-summary-price" onClick={() => setIsExpanded(!isExpanded)}>
                        <h6>
                            {isExpanded ? (
                            <RiArrowDropUpLine size={34}/>
                        ) : (
                            <RiArrowDropDownLine size={34}/>
                        )}
                            Order Summary - {cartItems.reduce((total, item) => total + (item.quantity || 1), 0)} Product(s)</h6>
                        <div className="order-summary-total">
                            <span className="sumarry-heading-total">Total: </span>₹{totalAmountOfProduct.toLocaleString("en-IN")}
                        </div>
                    </div>

                    {/* Cart Items (Show when Expanded) */}
                    {isExpanded && (
                        <div className="order-summary">
                            {isLoading && <Loader/>}
                            <div className="order-items">
                                {cartItems.length > 0 && !isLoading ? (
                                   
                                   
                              cartItems.length>0?     <>
                                        {cartItems.map((item, index) => {
    const hasFirst = !!item?.variant?.firstVariant?.title?.value;
    const hasSecond = !!item?.variant?.secondVariant?.title?.value;
    const variantValue = hasFirst && hasSecond
        ? `${item.variant.firstVariant.title.value.split("||")[0].trim()} / ${item.variant.secondVariant.title.value.split("||")[0].trim()}`
        : hasFirst
            ? item.variant.firstVariant.title.value.split("||")[0].trim()
            : hasSecond
                ? item.variant.secondVariant.title.value.split("||")[0].trim()
                : "";

    const variantProps = (hasFirst || hasSecond)
        ? { variantname: "Variant", value: variantValue }
        : {};

    return (
        <SingleCartProduct
            key={index}
            src={item.image}
            id={item.productId}
            {...variantProps}
            productName={item.title}
            price={item.price}
            mrp={item.mrp}
            newquantity={item.quantity}
            itemIndex={index}
            delcartitem={delcartitem}
            onQuantityChange={handleQuantityChange}
            stock={item.stock}
            variant={item.variant}
        />
    );
})}
                                    </>
:null
                                ) : (
                                    !isLoading && (
                                        <div className="cart-empty">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="50px"
                                                height="50px"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    style={{fill: "#3371a5"}}
                                                    d="M10 19.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5zm3.5-1.5c-.828 0-1.5.671-1.5 1.5s.672 1.5 1.5 1.5 1.5-.671 1.5-1.5c0-.828-.672-1.5-1.5-1.5zm1.336-5l1.977-7h-16.813l2.938 7h11.898zm4.969-10l-3.432 12h-12.597l.839 2h13.239l3.474-12h1.929l.743-2h-4.195z"
                                                />
                                            </svg>
                                            <p>Cart is empty</p>
                                        </div>
                                    )
                                )}
                                {isLoading && (
                                    <div className="cart-loading">
                                        <p>Loading...</p>
                                    </div>
                                )}
                            </div>
                            <div className="more-btn">
                                <button className="add-more-button" onClick={() => navigate(isPredefinedDomain ? `/${uid}` : "/")}>
                                    Add More Items <i className="fa-solid fa-plus more-btn-plus-icon"></i>
                                </button>
                            </div>
                            { cartItems.length > 0 && !isLoading && (
                    <>
                    <TotalPayment totalqtyprice={totalqtyprice}
                                  totalMrpPrice={totalMrpPrice}
                                  currentCoupon={currentCoupon}
                                  couponDiscountAmount={couponDiscountAmount}
                                  shippingCharges={shippingCharges}
                                  totalAmountOfProduct={totalAmountOfProduct}
                    />
                    </>
                )}
                        </div>
                    )}
</div>



                {/* {isCartLoginRequired && (
                    <div className='form-fild pt-3 p-3 h-100vh'>
                        <form onSubmit={handleButtonClick}>
                            <div className='position-relative'>
                                <div className='wrap-fildset'>
                                    <input
                                        className='number-fild'
                                        type='number'
                                        placeholder='Enter your mobile number'
                                        value={mobileNumber}
                                        onChange={handleInputChange}
                                    />
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path d="..." fill="#858585"/>
                                    </svg>
                                </div>
                                <label className='floatlavel'>Mobile Number</label>
                            </div>
                            {error && <p className='error-message pt-1 text-danger'>{error}</p>}

                            <CommonButton
                                type="submit"
                                name={"Generate OTP"}
                            />
                        </form>
                    </div>
                )} */}

                {/* {isOtpVerificationRequired && (
                    <div className='form-fild pt-5 p-3 h-100vh'>
                        <div className='inner-det'>
                            <h2>OTP Verification</h2>
                            <p>Enter the OTP sent on your phone number </p>
                        </div>
                        <form onSubmit={handleVerifyClick}>
                            <div className='position-relative'>
                                <div className='wrap-fildset'>
                                    <input className='number-fild' type='text' disabled
                                           placeholder='Enter your mobile number' value={`+91 ${mobileNumber}`}/>
                                    <Link className='changelink' to={isPredefinedDomain?`/${uid}/login`:"/login"}>Change</Link>
                                </div>
                                <label className='floatlavel'>Mobile Number</label>
                            </div>

                            <div className='group-inputs mt-4'>
                                {values.map((value, index) => (
                                    <input
                                        key={index}
                                        type='number'
                                        value={value}
                                        onChange={(e) => handleOtpInputChange(index, e)}
                                        ref={(el) => (inputRefs.current[index] = el)}
                                    />
                                ))}
                            </div>
                            {loginstatus === 0 && (
                                <div className="form-check mt-5 pl-3" id='trm-c'>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckChecked"
                                        checked={isCheckboxChecked}
                                        onChange={() => setIsCheckboxChecked(!isCheckboxChecked)}
                                    />
                                    <label className="form-check-label" htmlFor="flexCheckChecked">
                                        I agree to the <Link className='tc-link' to={"#"}>Terms and Conditions</Link>
                                    </label>
                                </div>
                            )}

                            <CommonButton name={"Verify & Login "} onClick={handleVerifyClick}/>

                            <div className='d-flex justify-content-between mt-3'>
                                <div className='text-md'>Didn't receive an OTP?
                                    <button
                                        className={`resend border-0 bg-transparent ${timer > 0 ? 'resend-disabled' : ''}`}
                                        onClick={handleResendClick}
                                        disabled={timer > 0}
                                    >
                                        Resend
                                    </button>
                                </div>
                                <div className='timer-text'>{formatTimer(timer)}</div>
                            </div>
                        </form>
                        {errorMessage && <p className='error-message pt-2 text-danger'>{errorMessage}</p>}
                    </div>
                )} */}
                    <div>
                        {
                            cartItems.length > 0 && (
                                <>
                                    {(shippingfeelivestatus === 1 ||
                                        pgfeelivestatus === 1 ||
                                        currentCoupon !== "") && (
                                        <>
                                            <div>
                                                {/* pf fee */}
                                                {/* {pgfeelivestatus === 1 ? (
                                                    <div className="d-flex justify-content-between">
                                                        <p
                                                            style={{
                                                                marginBottom: "0px",
                                                                fontSize: "14px",
                                                                color: "#333",
                                                            }}
                                                        >
                                                            Payment Gateway Charges
                                                        </p>
                                                        <p
                                                            style={{
                                                                marginBottom: "0px",
                                                                fontSize: "14px",
                                                                color: "#333",
                                                            }}
                                                        >
                                                            Rs. {paymentGatewayCharges}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    ""
                                                )} */}
                                            </div>
                                        </>
                                    )}

                                    {/* COUPONS */}
                                    {/* <CouponComponent availableCoupons={coupons}/> */}

                                    <InfoDialog
                                        show={showModal}
                                        onClose={() => setShowModal(false)}
                                        outOfStockMessage="Some of your selected products are out of stock or not available."
                                    />

                                    <PaymentMethods selectedPayment={selectedPayment} setSelectedPayment={setSelectedPayment}/>
                                    <AddressComponent addresses={addresses}
                                                      setRefreshAddresses={setRefreshAddresses}
                                                      setSelected={setSelected}
                                                      selected={selected}
                                                      isCartItemUpdated={isCartItemUpdated}
                                                      defaultAddress = {defaultAddress}
                                                      setDefaultAddress={setDefaultAddress}
                                    />
                                </>
                            )}

                        {/* ORDER NOW BUTTON */}

                        <button
                            style={{
                                backgroundColor: selected ? "#ff0000" : "#d3d3d3",
                                color: "#fff",
                                border: "none",
                                borderRadius: "10px",
                                padding: "14px",
                                width: "100%",
                                marginTop: "30px",
                                fontWeight: "600",
                                position:"sticky",
                                bottom:"5px"
                            }}
                            onClick={() => {
                                placeOrder();
                            }}
                            disabled={!selected && isCartItemUpdated ||loadingO||!selected||cartItems.length===0} // Disable button if no address is selected or some of the item are out of stock
                        >
                            {loadingO?"Processing":"Buy Now"}
                        </button>
                    </div>

                {/* <div className="bg-white">
      {cartItems.length > 0 ? (
          <button
            id="CTAbtn"
            className="btn"
            style={{
              display: "flex",
              width: "90%",
              padding: "10px",
              borderRadius: "10px",
              backgroundColor: "#3371A5",
              color: "#fff",
              alignItems: "center",
              justifyContent: "center",
              bottom: "14px",
              left: "0",
              right: "0",
              marginLeft: "auto",
              marginRight: "auto",
              gap: "14px",
            }}

            onClick={() => { handelprocesstobuy() }}
            disabled={cartItems?.length === 0}
          >
            <p style={{ marginBottom: "0px" }} className={"secondary-font-color"}>
              Proceed to Buy
            </p>
          </button>
        ) : (
          ""
        )}
      </div> */}
            </div>
        </CommonLayout>
    );
};

export default Cart
